export const NETWORK_ERROR_ACTION = '@app/ui/networkError';
export const SHOW_PRELOADER_ACTION = '@app/ui/showPreloader';
export const HIDE_PRELOADER_ACTION = '@app/ui/hidePreloader';
export const UPDATE_MUTATION_AND_CURRENCY_ACTION = '@app/ui/updateMutationAndCurrency';

export const networkErrorAction = (msg) => ({
	type: NETWORK_ERROR_ACTION,
	msg
});

export const showPreloaderAction = () => ({
	type: SHOW_PRELOADER_ACTION
});

export const hidePreloaderAction = () => ({
	type: HIDE_PRELOADER_ACTION
});

export const updateMutationAndCurrencyAction = (mutation, currency) => ({
	type: UPDATE_MUTATION_AND_CURRENCY_ACTION,
	currency,
	mutation
});


// WEBPACK FOOTER //
// ./actions/UiActions.js